export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";